import { UserInfoType } from '../models/user.types'

export type ProPricing = {
  v2: boolean
  monthly: number
  yearly: number
  yearlyTotal: number
  discount: number
}

const OLD_PRO_PRICING: ProPricing = {
  v2: false,
  monthly: 5,
  yearly: 4,
  yearlyTotal: 48,
  discount: 20,
}

const NEW_PRO_PRICING: ProPricing = {
  v2: true,
  monthly: 8,
  yearly: 7,
  yearlyTotal: 84,
  discount: 13,
}

export const getProPricing = (userInfo: UserInfoType): ProPricing => {
  if (new Date() >= new Date('2025-11-15')) {
    return NEW_PRO_PRICING
  }

  const whitelist = [
    'shivhduvvuru@gmail.com',
    'luca@skipper.co',
    'dara.m.wilson@gmail.com',
    'kwarudkar@gmail.com',
  ]

  const isCreatedAfterJuly2025 =
    userInfo?.date_joined && new Date(userInfo.date_joined) >= new Date('2025-07-01')
  const isWhitelisted = whitelist.includes(userInfo.email)
  const isV2 = isCreatedAfterJuly2025 || isWhitelisted

  if (isV2) {
    return NEW_PRO_PRICING
  } else {
    return OLD_PRO_PRICING
  }
}
